var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { attrs: { id: "loader-wrapper" } }, [
        _c("div", { attrs: { id: "loader" } }),
        _c("div", { staticClass: "loader-section section-left" }),
        _c("div", { staticClass: "loader-section section-right" }),
        _c("div", { staticClass: "load_title" }, [
          _vm._v("正在登录 JeecgBoot 低代码平台，请耐心等待")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }